export const ONBOARDING_STORAGE_KEY = 'sandbox:onboarding:v1';
export const ONBOARDING_RESTART_EVENT = 'sandbox:onboarding:restart';

type OnboardingStorage = Pick<Storage, 'getItem' | 'setItem' | 'removeItem'>;

export const isOnboardingCompleted = (storage: OnboardingStorage): boolean =>
  storage.getItem(ONBOARDING_STORAGE_KEY) === 'completed';

export const completeOnboarding = (storage: OnboardingStorage): void => {
  storage.setItem(ONBOARDING_STORAGE_KEY, 'completed');
};

export const resetOnboarding = (storage: OnboardingStorage): void => {
  storage.removeItem(ONBOARDING_STORAGE_KEY);
};

export const restartSandboxOnboarding = (): void => {
  window.dispatchEvent(new Event(ONBOARDING_RESTART_EVENT));
};
